import PropTypes from "prop-types";
import clsx from "clsx";
import { Link } from "react-router-dom";

const FooterCopyright = ({
  footerLogo,
  spaceBottomClass,
  colorClass,
  description,
  title,
}) => {
  return (
    <div className={clsx("copyright", spaceBottomClass, colorClass)}>
      <div>
        <Link to={"/"}>
          <img
            alt="store-logo"
            loading="lazy"
            className="rounded-3"
            src={footerLogo}
            width={"120px"}
          />
        </Link>
      </div>
      <h5 className="mb-1 fw-semibold mt-2 text-white">{title}</h5>
      <p className="fw-medium px-2">{description}</p>
    </div>
  );
};

FooterCopyright.propTypes = {
  footerLogo: PropTypes.string,
  spaceBottomClass: PropTypes.string,
  colorClass: PropTypes.string,
};

export default FooterCopyright;
